// Documentation: https://www.twilio.com/docs/voice/client/javascript/device

import { Device } from 'twilio-client';
import { apolloClient } from '@/services/apollo';
import $auth from '@/services/auth';
import { InsertCallToken } from '@/gql/members/Members.gql';
import regeneratorRuntime from 'regenerator-runtime';

const number = '+16463286644';
var activeMember = activeMember;

async function init() {
  let data = await apolloClient.mutate({
    mutation: InsertCallToken
  })
  const token = data.data.insert_CallToken;
  Device.setup(token, {
    closeProtection: true
  });
}
async function endSession() {
  Device.destroy();
}

async function call(member) {
  activeMember = member;
  Device.connect({
    phoneNumber: member.phone,
    toId: member.id,
    agent: $auth.getUserId()
  })
}

async function hangup() {
  Device.disconnectAll();
}

function getActiveCall() {
  return activeMember;
}

export default {
  init,
  endSession,
  number,
  call,
  hangup,
  status,
  getActiveCall
}
